import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  reportsRequest: ['props'],
  reportsSuccess: ['data'],
  reportsFailure: ['error'],
});

export const ReportsTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  totalPages: 0,
  currentPage: 1,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) => {

  if (data && data.removedId) {
    data.data = state.data.filter(r => r.id !== data.removedId);
    data.totalPages = state.totalPages;
    data.page = state.currentPage;
  }

  return state.merge({
    fetching: false,
    error: null,
    data: data ? data.page && data.page > 1 ? [...state.data, ...data.data] : data.data : null,
    totalPages: data && data.totalPages ? data.totalPages : 0,
    currentPage: data && data.page ? data.page : 1,
  });
}

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.REPORTS_REQUEST]: request,
  [Types.REPORTS_SUCCESS]: success,
  [Types.REPORTS_FAILURE]: failure,
});
